import { Box, Modal, ScrollArea } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import type { CollaborationPaymentSuccessData } from "../hooks/useCollaborationEngagementPayment";
import CollaborationPaymentSuccessContent from "./CollaborationPaymentSuccessContent";

/** Max width for payment success modal (desktop). */
export const PAYMENT_SUCCESS_MODAL_MAX_WIDTH = 1120;

type CollaborationPaymentSuccessModalProps = {
  opened: boolean;
  onClose: () => void;
  paymentData: CollaborationPaymentSuccessData | null;
};

export default function CollaborationPaymentSuccessModal({
  opened,
  onClose,
  paymentData,
}: CollaborationPaymentSuccessModalProps) {
  const isMobile = useMediaQuery("(max-width: 576px)", false, { getInitialValueInEffect: true });

  if (!paymentData) return null;

  const content = <CollaborationPaymentSuccessContent paymentData={paymentData} onClose={onClose} />;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius={isMobile ? 0 : "lg"}
      size={isMobile ? "100%" : "auto"}
      fullScreen={isMobile}
      withCloseButton={false}
      padding={isMobile ? "md" : "xl"}
      overlayProps={{ backgroundOpacity: 0.45, blur: 2 }}
      styles={{
        inner: { overflow: "hidden", padding: isMobile ? 0 : undefined },
        content: {
          maxWidth: isMobile ? "100%" : `min(${PAYMENT_SUCCESS_MODAL_MAX_WIDTH}px, calc(100vw - 2rem))`,
          width: "100%",
          overflow: "hidden",
        },
        body: {
          overflow: "hidden",
          ...(isMobile ? { display: "flex", flexDirection: "column", maxHeight: "100dvh" } : {}),
        },
      }}
    >
      {isMobile ? (
        <ScrollArea style={{ flex: 1 }} type="auto" offsetScrollbars scrollbarSize={6}>
          <Box pb="xs">{content}</Box>
        </ScrollArea>
      ) : (
        content
      )}
    </Modal>
  );
}
